"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFilterOption = void 0;
const products_1 = require("@getgreenline/products");
const mobx_1 = require("mobx");
class QueryFilterOption {
    constructor() {
        this.QUERY_LIMIT = 3;
        this.searchQuery = '';
        this.setQuery = (query) => {
            this.searchQuery = query || '';
        };
        this.reset = () => {
            this.searchQuery = '';
        };
        this.queryExists = ({ POSListings, listing }) => {
            return this.targetSearchString({
                POSListings,
                listing,
            }).includes(this.sanitizedQuery);
        };
        this.normalizeString = (str) => {
            // replace single quotation mark unicode with apostrophe
            return str.replace(/[\u2018\u2019]/g, '\u0027');
        };
        this.targetSearchString = ({ POSListings, listing }) => {
            const name = (listing.name || '').toLowerCase();
            const sku = (listing.sku || '').toLowerCase();
            const barcode = (listing.barcode || '').toLowerCase();
            const parentName = listing.parentProductId && listing.parentProductName
                ? listing.parentProductName.toLocaleLowerCase()
                : '';
            const defaultSearchStringItems = [parentName, name, sku, barcode];
            const terpeneMap = new Map();
            Object.values(products_1.MetaDataModels.TerpeneReservedKeys).forEach((terp) => {
                terpeneMap.set(terp, terp);
            });
            const metaData = Object.keys(listing.metaData);
            let terpeneString = '';
            const batches = POSListings.products.batches.getAllPerProduct(listing.id);
            batches.forEach((batch) => {
                if (!(batch === null || batch === void 0 ? void 0 : batch.cannabinoidMetaData) || (batch === null || batch === void 0 ? void 0 : batch.cannabinoidMetaData.length) === 0)
                    return;
                batch.cannabinoidMetaData[0].metaData.forEach((item) => {
                    if (terpeneMap.get(item.metaKey)) {
                        terpeneString += item.metaKey;
                    }
                });
            });
            metaData.forEach((key) => {
                if (terpeneMap.get(key)) {
                    terpeneString += key;
                }
            });
            return [...defaultSearchStringItems, terpeneString.toLowerCase()].join(' ');
        };
    }
    get isSet() {
        return this.searchQuery.length >= this.QUERY_LIMIT;
    }
    get sanitizedQuery() {
        return this.normalizeString(this.searchQuery.trim()).toLowerCase();
    }
}
exports.QueryFilterOption = QueryFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], QueryFilterOption.prototype, "searchQuery", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], QueryFilterOption.prototype, "setQuery", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], QueryFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], QueryFilterOption.prototype, "isSet", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], QueryFilterOption.prototype, "sanitizedQuery", null);
//# sourceMappingURL=QueryFilterOption.js.map